import { FC } from "react";
import { Button, Icon, Box, Stack, Container, Typography, IconButton } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import EmailIcon from '@mui/icons-material/Email';
import LocationIcon from '@mui/icons-material/LocationOn';
import PolicyIcon from '@mui/icons-material/Policy';
import CopyrightIcon from '@mui/icons-material/Copyright';
import ImageSearchIcon from '@mui/icons-material/ImageSearch';

// common
import { ActionCB } from "@common/type_defs";
import { defs } from "@common/const_defs";
import info from "@data/company-info";

const Footer: FC<{ onAction: ActionCB }> = ({ onAction }) => {
  return (
    <Grid
      alignItems="center"
      flexDirection={{ xs: 'column', sm: 'row' }}
      sx={{ mt: 0, backgroundColor: 'rgb(33,33,33)', color: 'white' }}
    >
      <Container component="main" sx={{ mb: 2, }}>
        <Grid container>
          <Grid lg={4} md={4} sm={12}>
            <Box sx={{ p: 2 }}>
              <Typography component="span" color="#ffffff" sx={{ fontSize: "22px", fontWeight: 600, pb: '5px', borderBottom: '2px solid #ff6d00' }}>About Us</Typography>
              <Box sx={{ ml: 0, my: 2, color: '#ffffff', fontSize: '12px' }}>
                これからのエネルギー・ビジネス、<br />
                一緒に考えてみませんか？<br />
                お気軽にご連絡ください。
              </Box>
              <Button variant="contained" color="secondary" onClick={() => onAction(defs.kAct_ViewContactUsOpen, null)}>
                Contact Us
              </Button>
            </Box>
          </Grid>
          <Grid lg={4} md={4} sm={12}>
            <Box sx={{ p: 2 }}>
              <Typography component="span" color="#ffffff" sx={{ fontSize: "22px", fontWeight: 600, pb: '5px', borderBottom: '2px solid #ff6d00' }}>Contact</Typography>
              <Stack direction="row" sx={{ mt: 3, gap: '4px', alignItems: 'center' }}>
                <EmailIcon sx={{ color: "#ff6d00", fontSize: 20, ml: '1px' }} />
                <Box component="a" href={`mailto:${info.email}`} target='blank' sx={{ ml: '2px', color: '#ffffff', fontSize: '12px' }}>{info.email}</Box>
              </Stack>
              <Stack direction="row" sx={{ my: 2, gap: '4px', alignItems: 'center' }}>
                <LocationIcon sx={{ color: "#ff6d00", fontSize: 22, ml: '0px' }} />
                <Box sx={{ ml: 0, color: '#ffffff', fontSize: '12px' }}>
                  {info.address}<br />
                  {info.addr2}
                </Box>
              </Stack>
            </Box>
          </Grid>
          <Grid lg={4} md={4} sm={12}>
            <Box sx={{ p: 2 }}>
              <Typography component="span" color="#ffffff" sx={{ fontSize: "22px", fontWeight: 600, pb: '5px', borderBottom: '2px solid #ff6d00' }}>Copyright</Typography>
              <Stack direction="row" sx={{ mt: 3, gap: '4px', alignItems: 'center' }}>
                <CopyrightIcon sx={{ color: "#ff6d00", fontSize: 20 }} />
                <Box component="span" sx={{ ml: 1, color: '#ffffff', fontSize: '12px' }}>
                  <a href={info.website} target='blank'>{info.name}</a>
                </Box>
              </Stack>
              <Stack direction="row" sx={{ mt: 3, gap: '4px', alignItems: 'center' }}>
                <ImageSearchIcon sx={{ color: "#ff6d00", fontSize: 20 }} />
                <Box component="span" sx={{ ml: 1, color: '#ffffff', fontSize: '12px' }}>
                  Partial Images <a href="http://www.freepik.com" target='blank' rel="noreferrer">Designed by Freepik</a>
                </Box>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Grid>
  )
};

export default Footer;
